// extracted by mini-css-extract-plugin
export default {"pageTableScrollable":"widget_pageTableScrollable__P0VC9","reportTableScrollable":"widget_reportTableScrollable__-jFAu","reportTableWrapper":"widget_reportTableWrapper__fTABU"};